import { AnimatePresence, motion } from 'framer-motion';
import { useBranding } from '../state/branding';
import { ShotSelectLogo } from './ShotSelectLogo';

interface BrandingBadgeProps {
  /** 'sm' for the 2-col grid cards, 'md' for the full photo view */
  size?: 'sm' | 'md';
}

export function BrandingBadge({ size = 'md' }: BrandingBadgeProps) {
  const visible = useBranding((s) => s.visible);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.85 }}
          transition={{ duration: 0.15, ease: 'easeOut' }}
          aria-hidden
          className={[
            'absolute pointer-events-none select-none',
            'flex items-center',
            'bg-black/52 backdrop-blur-md',
            size === 'sm'
              ? 'bottom-1.5 right-1.5 gap-[3px] px-1.5 py-[3px] rounded-md'
              : 'bottom-3 right-3 gap-1.5 px-2.5 py-[5px] rounded-lg',
          ].join(' ')}
          style={{
            boxShadow:
              size === 'md'
                ? '0 1px 6px rgba(0,0,0,0.5), inset 0 0.5px 0 rgba(255,255,255,0.12)'
                : undefined,
          }}
        >
          <ShotSelectLogo
            className="flex-shrink-0"
            style={{ width: size === 'sm' ? 10 : 13, height: size === 'sm' ? 10 : 13 }}
          />
          {size === 'md' ? (
            <span className="text-white/80 text-[10px] font-semibold tracking-[0.1em] uppercase leading-none">
              ShotSelect
            </span>
          ) : (
            <span className="text-white/75 text-[7.5px] font-bold tracking-[0.12em] uppercase leading-none">
              SS
            </span>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
